module.exports = __webpack_public_path__ + "static/media/14UNEP7.cbfca25f.jpg";